import { PrismicNextImage } from "@prismicio/next";


const AuthorCard = ({ author }) => (
  <div className="flex flex-row items-center gap-2.5">
    <PrismicNextImage 
    field={author.data.author_picture} loading="eager" fetchPriority="high" className="h-5 w-5 object-cover rounded-full" />
    <p className="p-sm-n lt text-bleu-90">Écrit par {author.data.author_name}</p>
  </div>
);

export default AuthorCard;
